/**
 * Represents the Calendar widget of the Search Results page
 * @param {string} id The DOM identifier for the calendar div, including its "#" character
 */
function SearchCalendar(id) {
    this.elem = document.getElementById(id);
    this.startDate = null;
    this.visible = 13;
    this.today = this.formatDateRead(new Date());

    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    jQuery(document).on("searchFormChangeDisplay", this.searchFormChangeDisplay.bind(this));

    jQuery(this.elem).on("click", ".va-grid-next", this.gridNext.bind(this));
    jQuery(this.elem).on("click", ".va-grid-prev", this.gridPrev.bind(this));

    this.initialize();
}


/**
 * Date format validator
 * @param  {Date} s date in M(M)/D(D)/(YY)YY format
 * @return {boolean} True if date is valid
 */
function isValidDate(s) {
    var dateFormat = /^\d{1,2}[\.|\/|-]\d{1,4}[\.|\/|-]\d{1,4}$/;

    if (dateFormat.test(s)) {
        // remove any leading zeros from date values
        s = s.replace(/0*(\d*)/gi,"$1");
        var dateArray = s.split(/[\.|\/|-]/);

        // correct month value
        dateArray[0] = dateArray[0] - 1;

        // correct year value
        if (dateArray[2].length < 4) {
            // correct year value
            dateArray[2] = (parseInt(dateArray[2]) < 50) ? 2000 + parseInt(dateArray[2]) : 1900 + parseInt(dateArray[2]);
        }

        var testDate = new Date(dateArray[2], dateArray[0], dateArray[1]);

        if (testDate.getDate() != dateArray[1] || testDate.getMonth() != dateArray[0] || testDate.getFullYear() != dateArray[2]) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * Triggered when the calendar is advancing forward to the next date
 */
SearchCalendar.prototype.gridNext = function() {
    this.setVisible();
    var new_date = this.dateAdd(this.startDate,this.visible);
    this.setGridStart(new_date, true);
};

/**
 * Triggered when the calendar is advancing backward to the previous date
 */
SearchCalendar.prototype.gridPrev = function() {
    this.setVisible();
    var new_date = this.dateAdd(this.startDate, -this.visible);
    this.setGridStart(new_date, true);
};

/**
 * Assigns the visible attribute for some of the grid rows with the number of visible days
 * @todo Document this better?
 */
SearchCalendar.prototype.setVisible = function() {
    for(i=13; i>0; i--){
        if(jQuery("#rentals-container th.grid-col" + i).is(":visible")){
            this.visible = i;
            break;
        }
    }
};

/**
 * Adds a certain amount of days to a date
 * @param  {string} date   The date to change
 * @param  {integer} offset The number of days to change it by
 * @return {string}        The new date
 */
SearchCalendar.prototype.dateAdd = function(date, offset) {
    var parts = date.match(/(\d+)/g);
    var i = new Date(parts[2], parts[0]-1, parts[1]); // months are 0-based
    i.setDate(i.getDate() + offset);
    return this.formatDateRead(i);
};

/**
 * Determines the difference between two given dates
 * @param  {Date} date1    The date to compare
 * @param  {Date} date2    The date to compare it to
 * @return {integer}       The number of days between the two dates
 */
SearchCalendar.prototype.dateDiff = function(date1, date2) {
    //Get 1 day in milliseconds
    var one_day=1000*60*60*24;

    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    return Math.round(difference_ms/one_day);
};

/**
 * Formats the given date in a standard way
 * @param  {Date} d A given date object
 * @return {string}   The formatted date string
 * @todo This will need to be internationalized (i18n)
 */
SearchCalendar.prototype.formatDateRead = function(d) {
    return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
};

/**
 * Sets the first date that the grid should display
 * @param {string} date   The date to change to
 * @param {boolean} update If true, will trigger a search operation
 */
SearchCalendar.prototype.setGridStart = function(date, update) {
    this.startDate = date;
    window.search_form.change({gridS:date});

    if(update) {
        window.search_form.update();
    }
};

/**
 * Sets the Grid range, includes show 2 days before first day logic
 * @param  {Date} start  first day
 * @param  {Date} end    last day
 * @return {string}      date if grid start
 */
SearchCalendar.prototype.getGridStartFromRange = function(start, end) {
    var diff = this.dateDiff(start, end);
    var new_date = this.formatDateRead(start);

    if(diff + 3 < this.visible) {
        new_date = this.dateAdd(new_date, -2);
    } else if(diff + 1 < this.visible) {
        new_date = this.dateAdd(new_date, -1);
    }

    // Making sure that first day is not in the past and is a valid date
    if(new_date < this.today || !isValidDate(new_date)) {
        new_date = this.today;
    }

    return new_date;
};

/**
 * Gradually animates returning to the top of the page
 */
SearchCalendar.prototype.scrollToTop = function() {
    jQuery('body, html').animate({
        'scrollTop': 0
    }, 200);
};

/**
 * Initializes the controls and events for this widget
 */
SearchCalendar.prototype.initialize = function() {
    var self = this;

    if(this.startDate === null) {
        this.startDate = jQuery("#gridS").val();
    }

    jQuery("#gridDate").datepicker({
        minDate: 0
    }).change(function(e) {
        self.setGridStart(jQuery(this).val(), true);
    });

    if (!jQuery.browser.mobile) {
        jQuery("a.va-grid-date").fancybox({
            type:"ajax"
        }).tooltip({
            position: {
                my: "center bottom",
                at: "center top-5",
                using: function( position, feedback ) {
                  jQuery( this ).css( position );
                  jQuery( "<div>" )
                    .addClass( "tooltip-arrow" )
                    .addClass( feedback.vertical )
                    .addClass( feedback.horizontal )
                    .appendTo( this );
                }
            },
            hide: false
        });
    }
    else{
         jQuery("a.va-grid-date").fancybox({
            type:"ajax"
        });
    }
};

/**
 * Called by an event when the search form type changes
 * @param  {Object} evt  The event object
 * @param  {string} type The type of search form being switched to
 */
SearchCalendar.prototype.searchFormChangeDisplay = function(evt, type) {
    this.scrollToTop();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchCalendar.prototype.searchComplete = function(evt, res, search) {
    this.scrollToTop();

    jQuery(this.elem).html(res.htmlCalendar);

    this.initialize();
};

window.SearchCalendar = SearchCalendar;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchCalendar.js
// module id = 4
// module chunks = 0